/** File is auto-generated by TypeWriter, a plug-in for Visual Studio. Modifications will be overridden when the template is rendered */


interface AdminExportUserRequest {
  userId: number;
}
const AdminExportUserRequest = {
  create: (initValues?: Partial<AdminExportUserRequest> | null): AdminExportUserRequest => {
    const defaults: AdminExportUserRequest = {
      userId: 0,
    };
    const fixedValues: Partial<AdminExportUserRequest> = initValues != null
      ? {
      }
      : {};
    return { ...defaults, ...initValues, ...fixedValues };
  }
};

export default AdminExportUserRequest;
